import * as Yup from "yup";

export const driverDetailsSchema = Yup.object().shape({
  driverName: Yup.string()
    .required("Driver name is required")
    .min(2, "Driver name must be at least 2 characters")
    .max(100, "Driver name must be less than 100 characters"),
  mobileNumber: Yup.string()
    .required("Mobile number is required")
    .matches(/^\d{10}$/, "Mobile number must be exactly 10 digits"),
  alternateMobileNumber: Yup.string()
    .required("Alternate mobile number is required")
    .matches(/^\d{10}$/, {
      message: "Alternate mobile number must be exactly 10 digits",
      excludeEmptyString: true,
    })
    .test(
      "different-mobile-number",
      "Alternate mobile number must be different from mobile number",
      function (value) {
        return !value || value !== this.parent.mobileNumber;
      },
    ),
  residentialAddress: Yup.string()
    .required("Residential address is required")
    .min(5, "Address must be at least 5 characters")
    .max(500, "Address must be less than 500 characters"),
  otherInformation: Yup.string(),
  age: Yup.number()
    .required("Age is required")
    .typeError("Age must be a number"),
  vehicleFinanced: Yup.string()
    .required("Vehicle purchase option is required")
    .oneOf(["No", "Yes"], "Please select a valid purchase option"),
});

export const getVehicleFinancierSchema = (vehicleFinanced) => {
  if (vehicleFinanced === "Yes") {
    return Yup.object().shape({
      vehicleFinancierName: Yup.string()
        .required("Financier name is required")
        .min(2, "Name must be at least 2 characters")
        .max(100, "Name must be less than 100 characters"),
      vehicleFinancierAddress: Yup.string()
        .required("Financier address is required")
        .min(5, "Address must be at least 5 characters")
        .max(500, "Address must be less than 500 characters"),
      vehicleFinancierPhone: Yup.string()
        .required("Phone number is required")
        .matches(/^\d{10}$/, "Phone number must be exactly 10 digits"),
    });
  }
  return Yup.object().shape({});
};